import { writable } from 'svelte/store';
import { api } from 'src/services/api/reallis';
// region isLoggedIn
export const isLoggedIn = writable(api.ws.ws1.auth.isLoggedIn);
api.ws.ws1.auth.on('login', () => {
    isLoggedIn.set(api.ws.ws1.auth.isLoggedIn);
});
api.ws.ws1.auth.on('logout', () => {
    isLoggedIn.set(api.ws.ws1.auth.isLoggedIn);
});
// export const auth: IAuthController = api.ws.ws1.auth
// endregion
// region 2fa
export const session = writable(api.ws.ws1.auth.session);
api.ws.ws1.auth.on('sessionChanged', () => {
    session.set(api.ws.ws1.auth.session);
});
// export const auth: IAuthController = api.ws.ws1.auth
// endregion
// region userProfile
export const userProfile = writable(api.ws.ws1.user.profile);
api.ws.ws1.user.on('profileChanged', () => {
    userProfile.set(api.ws.ws1.user.profile);
});
userProfile.subscribe(value => {
    if (value === null || value === void 0 ? void 0 : value.isBanned) {
        api.ws.ws1.auth.logout();
    }
});
// export const user: UserController = api.ws.ws1.user
// endregion
